<div class="d-flex flx-grow-1 flex-row mx-5 py-2 player-list-item" (click)="onPlayerSelected()">
  <div class="mr-2">
    <span class="ic-item-selected mt-3" *ngIf="isPlayerSelected"></span>
    <span class="ic-item-not-selected mt-3" *ngIf="!isPlayerSelected"></span>
  </div>
  <div class="flex-grow-1 player-list-column">
    <app-player-info [player]="player"></app-player-info>
  </div>
  <div class="flex-grow-1 d-flex flex-column  player-list-column">
    <div class="flex-grow-1">
      {{player.phoneNumber | phoneMask}}
    </div>
    <div class="flex-grow-1">
      {{player.eMail}}
    </div>
  </div>
</div>
